import '../Inscription.less';
import { Button, Layout,Menu , Row, Col,Modal,Select,ConfigProvider,Table} from 'antd';
import { BarChartOutlined} from '@ant-design/icons';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import moment from 'moment';
import es_ES from 'antd/lib/locale/es_ES';
import {NavLink} from "react-router-dom";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import generatePDFPlaysByCountry from './services/reports'
import {getAuthors,getAuthorsStr, getCountryName,IP} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"
 

class AdminHome extends Component {
  constructor(props){
    super(props)
    this.state={
      autores: {},
       authorsByCountry:{ },
       authorsByVillage:{ },
       todayPonencias : 0,
       todayPaneles : 0,
       totalPonencias : 0,
       totalPaneles: 0,
       totalAutores : 0,
       autoresPresenciales : 0,
       autoresVirtuales : 0,
       ponenciasAsociadas : 0,
       ponenciasNoAsociadas : 0,
       todayAutoresVillage: 0,
       totalAutoresVillage:0,
      
      conc_report:[],
      plays_report:[],
      makeGenreReport:false,
      reportByAuthor:true,
      reportGenre:'Cuento',
      reportCountry:null,
      makeCountryReport:false,
      isBusy:true
    }
  }
  async componentDidMount() {
    const paneles = await fetch(IP +'api/culturasOriginarias/panel/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_paneles = await paneles.json();
    if(json_paneles['detail']){//if no authorization,returns dict with detail key
      localStorage.clear()
      window.location.reload(); 
    }

    const ponencias = await fetch(IP + 'api/culturasOriginarias/ponencia/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });

   const json_ponencias= await ponencias.json();
    
    
   
    const json_conc = [].concat.apply([],json_ponencias.map(play=> {return play.conc}))
   
    var data_ponencias= []
    var data_paneles= []
  
    const Moment = require('moment');

    for(var i in json_paneles){//build plays data to display
      var item = json_paneles[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var pon = item.ponencias.map(p=>{return p.id})
      const year = date.split('-')[2]
      data_paneles.push(
          { 
              id : i,
              title : item.titulo,
              date:date,
              code:year+'_'+item.id,
              ponencias:pon,
          });
    };

    for(var i in json_ponencias){//build plays data to display
      var item = json_ponencias[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data_ponencias.push(
          { 
              id : i,
              title : item.titulo,
              author: author ,
              authorStr:authorStr,
              date:date,
              resumen: item.resumen,
              conc:item.conc,
              registradaSola:item.ponencia_registrada_sola,
              edit:''
          });
    };
    var data_conc = []
    for(var i in json_conc){//build concs data to display
      var item = json_conc[i];
    
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre + " " + item.apellidos,
              country: getCountryName(item.pais),
              participacionVirtual: item.participacionVirtual,
              phone: item.telefono,
              email: item.email,
          });
    };
    var authorsByCountry={ }
    var authorsByVillage={ }
    var todayPonencias = 0
    var todayPaneles = 0
    var todayAutores = 0
    var totalPonencias = 0
    var totalPaneles= 0
    var totalAutores = 0
    var autoresPresenciales = 0
    var autoresVirtuales = 0
    var ponenciasAsociadas = 0
    var ponenciasNoAsociadas = 0

    var todayAutoresVillage  = 0
    var totalAutoresVillage = 0

    for(var key in json_paneles){//build data for Plays by country Table and By Genre
      var panel = json_paneles[key]
      
      var panelDate = moment(panel.fecha_registro).format('DD-MM-YYYY')
      var today = moment().format('DD-MM-YYYY')

      if(today == panelDate){
        todayPaneles += 1
      }
      totalPaneles += 1
    }

    for(var key in json_ponencias){//build data for Plays by country Table and By Genre
      var ponencia = json_ponencias[key]
      var ponenciaDate = moment(ponencia.fecha_registro).format('DD-MM-YYYY')
      var today = moment().format('DD-MM-YYYY')

      if(ponencia.ponencia_registrada_sola)
        ponenciasNoAsociadas +=1
      else
        ponenciasAsociadas +=1

      if(today == ponenciaDate){
        todayPonencias += 1
      }
      for(var a in ponencia.conc){
        var aut = ponencia.conc[a]
        if(aut.participacionVirtual)
          autoresVirtuales += 1
        else
          autoresPresenciales += 1
        var country =aut['pais']
        console.log("PAIS",aut)
        var countryName = getCountryName(country)
        var villageName = aut['pueblo']
        if(!(countryName in authorsByCountry)){
          authorsByCountry[countryName] ={}
          authorsByCountry[countryName]["total"] = 0
          authorsByCountry[countryName]["today"] = 0
        }
        if(today == ponenciaDate){
          authorsByCountry[countryName]["today"] += 1
          todayAutores += 1
        }
          
        authorsByCountry[countryName]["total"] += 1

        if(villageName.replace(/ /g,'') != ""){
          if(  !(villageName in authorsByVillage)){
            authorsByVillage[villageName] ={}
            authorsByVillage[villageName]["total"] = 0
            authorsByVillage[villageName]["today"] = 0
          }
          if(today == ponenciaDate){
            authorsByVillage[villageName]["today"] += 1
            todayAutoresVillage += 1
          }
            
          authorsByVillage[villageName]["total"] += 1
        totalAutoresVillage +=1

        }
       
      }
      totalPonencias += 1
      totalAutores+= Object.keys(ponencia.conc).length
    }
    console.log("PUEBLO",authorsByVillage)
    this.setState({todayAutoresVillage:todayAutoresVillage,totalAutoresVillage:totalAutoresVillage, todayAutores:todayAutores,isBusy:false,authorsByVillage:authorsByVillage, authorsByCountry:authorsByCountry,todayPonencias:todayPonencias,todayPaneles:todayPaneles,totalPonencias:totalPonencias,totalPaneles:totalPaneles,totalAutores:totalAutores,autoresPresenciales:autoresPresenciales,autoresVirtuales:autoresVirtuales, ponenciasAsociadas:ponenciasAsociadas,ponenciasNoAsociadas:ponenciasNoAsociadas})
    
    // this.setState({ plays: {},todayPlays:todayPlays,todayConc:todayConc, totalConc:totalConc,totalPlays:Object.keys(json_plays).length,isBusy:false,conc_report: data_conc, plays_report: data_play });
  }
 
  render() {
    const { Content } = Layout;
    const { Option } = Select;
    const { SubMenu } = Menu;
    const { Column, ColumnGroup } = Table;
    
    const dataC = [//Concs Table
      {
        key: '1',
        todayConc: this.state.au,
        totalConc: this.state.totalConc,
      },
    ];

    const dataAuthors= [
    {
      key: '1',
      virtual: <div style={{fontSize:'large' }}>{this.state.autoresVirtuales}</div>,
      presencial:<div style={{fontSize:'large' }}>{this.state.autoresPresenciales}</div> ,
      
    },
  ]

  const dataPaneles= [
    {
      key: '1',
      hoy: <div style={{fontSize:'large' }}>{this.state.todayPaneles}</div>,
      total:<div style={{fontSize:'large' }}>{this.state.totalPaneles}</div> ,
      
    },
  ]
    var dataAuthorsCountry =  Object.keys(this.state.authorsByCountry).map((k,index)=>// By country
      {
        var row = {
          key:index,
          country:k,
        }
          row["today"]= this.state.authorsByCountry[k]["today"]
          row["total"]= this.state.authorsByCountry[k]["total"]
        return row
      })
      

      dataAuthorsCountry = dataAuthorsCountry.sort((a, b) => a.country.localeCompare(b.country))//Sort By country Name
      dataAuthorsCountry.push(
      {
        key: "TOTAL",
        country:<div style={{fontSize:'large', fontWeight:'bold' }}>Total</div>,
        today: this.state.todayAutores,
        total: this.state.totalAutores,
        
      },
    )

    var dataAuthorsVillage =  Object.keys(this.state.authorsByVillage).map((k,index)=>// By country
      {
        var row = {
          key:index,
          village:k,
        }
          row["today"]= this.state.authorsByVillage[k]["today"]
          row["total"]= this.state.authorsByVillage[k]["total"]
        return row
      })
      

      dataAuthorsVillage = dataAuthorsVillage.sort((a, b) => a.village.localeCompare(b.village))//Sort By country Name
      dataAuthorsVillage.push(
      {
        key: "TOTAL",
        village:<div style={{fontSize:'large', fontWeight:'bold' }}>Total</div>,
        today: this.state.todayAutoresVillage,
        total: this.state.totalAutoresVillage,
        
      },
    )
    const dataPonencias = [//By genre
      {
        key: '1',
        todayPon:<div style={{fontSize:'large' }}>{this.state.todayPonencias}</div>,
        totalPon: <div style={{fontSize:'large' }}>{this.state.totalPonencias}</div>,
        asocPon:<div style={{fontSize:'large' }}>{this.state.ponenciasAsociadas}</div> ,
        notAsocPon:<div style={{fontSize:'large' }}>{this.state.ponenciasNoAsociadas}</div> ,
        
      },
    ];

    //Conc's Reports
    const downloadConcReport =()=> generatePDFConc(this.state.conc_report,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc_report,"read")
    // 

    //Play's Reports
      //General by author
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays_report,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays_report,"read")
      //General by pseudo
    const downloadPlayReportPseudo =()=> generatePDFPlay(this.state.plays_report,"save",false,false,'',false)
    const readPlayReportPseudo =()=> generatePDFPlay(this.state.plays_report,"read",false,false,'',false)

    const downloadPlayCountryReport =()=> generatePDFPlaysByCountry(dataAuthorsCountry,"save")
    const readPlayCountryReport =()=> generatePDFPlaysByCountry(dataAuthorsCountry,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,true)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,true)

    const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenre =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read")

    const downloadPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>p.category == this.state.reportGenre),"read",false,false,'',false)


    const downloadPlayReportSelectedCountryPseudo=()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,false)
    const readPlayReportSelectedCountryPseudo =()=> generatePDFPlay(this.state.plays_report.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,false)
    const onClickGenreReport=()=>{
      this.setState({makeGenreReport:true})
    }
    const onClosekGenreReport=()=>{
      this.setState({makeGenreReport:false})
    }
    const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}

    const onClickCountryReport=()=>{
      this.setState({makeCountryReport:true})
    }
    const onClosekCountryReport=()=>{
      this.setState({makeCountryReport:false})
    }
    const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}


    const reportMenu = (
    <SubMenu disabled={this.state.isBusy} key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
      <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
        <SubMenu  key="playAuth" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con autores</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
            <Menu.Item>
                <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
            </Menu.Item>
          </Menu.ItemGroup>
          <Menu.Item>
            <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
          </Menu.Item>
          <Menu.Item style={{ fontWeight:'bold'}} >
            <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
          </Menu.Item>
        </SubMenu>
        <SubMenu  key="playPseudo" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con seudónimo</h4>}>
          <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportPseudo}>Ver</Button> <Button onClick={downloadPlayReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Item>
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>
            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
        </SubMenu>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>Por países</h4>}>
          <Menu.Item>
            <Button onClick={readPlayCountryReport}>Ver</Button> <Button onClick={downloadPlayCountryReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
      <SubMenu  key="r" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
          <Menu.Item>
            <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
    </SubMenu>)
    return (
          <div className="page-container">
            <div className = "content-wrap">
              <ConfigProvider locale={es_ES}>
                <Layout style={{backgroundColor:'white'}}>
                  <AdminMenu defaultSelectedKey={"home"} reportMenu={reportMenu} />
                  <Content>
                  <Row  justify="center" align="middle" >
                  <Col span={12}>
                    <br></br>
                    <Row  justify="center" align="middle" >
                    <Table loading={this.state.isBusy} bordered dataSource={dataPaneles} pagination={false} size='small' style={{fontSize:'large'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/culturasOriginarias/admin_pan">Paneles</NavLink> </div>}>
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="hoy" key="hoy" align='center' render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                          <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)}dataIndex="total" key="total"  align='center'render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: record.key == 4 ? '#e6e6e6' : "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} } />
                        </ColumnGroup>
                      </Table>
                      </Row>
                      <br/>
                      <Row  justify="center" align="middle" >
                
                        <Col span={12} >
                          
                          <Table loading={this.state.isBusy}  bordered dataSource={dataPonencias} pagination={false}size='small' >
                            <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/culturasOriginarias/admin_pon">Ponencias</NavLink></div>}>
                              <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Hoy</div>)} dataIndex="todayPon" key="todayPon" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Total</div>)} dataIndex="totalPon" key="totalPon" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background: "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                                <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>Asociadas a Paneles</div>)} dataIndex="asocPon" key="asocPon" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                                <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>No Asociadas a Paneles </div>)} dataIndex="notAsocPon" key="notAsocPon" align='center'
                              render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background: "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                            </ColumnGroup>
                          </Table>
                        </Col>
                
                      </Row>
                    </Col>

                    <Col span={8}>
                      <br></br>
                      <Row  justify="center" align="middle" >
                      <Table loading={this.state.isBusy} bordered dataSource={dataAuthors} pagination={false} size='small' style={{fontSize:'x-large', marginLeft:'10px'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> <NavLink to="/culturasOriginarias/admin_conc">Autores</NavLink> </div>}>
                              <Column title={(<div style={{  fontSize:'large'}}>Presenciales</div>)} dataIndex={"presencial"} key="presencial" align='center' render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:"white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontSize:'large'}}>Virtuales</div>)}dataIndex={"virtual"} key="virtual"  align='center'render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                         
                
                        </ColumnGroup>
                      </Table>
                      </Row>
                      <br/>
                      <Row  justify="center" align="middle" >
                      <Table loading={this.state.isBusy} bordered dataSource={dataAuthorsCountry} pagination={false} size='small' style={{fontSize:'x-large', marginLeft:'10px'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> Autores por Paises</div>}>
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>
                          País</div>)} dataIndex="country" key="genre" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} }
                          
                            />
                            
                        
                              <Column title={(<div style={{  fontSize:'large'}}>Hoy</div>)} dataIndex={"today"} key="todayPlays" align='center' render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:"white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontSize:'large'}}>Total</div>)}dataIndex={"total"} key="totalPlays"  align='center'render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                         
                
                        </ColumnGroup>
                      </Table>
                      </Row>
                      <br/>

                      <br/>
                      <Row  justify="center" align="middle" >
                      <Table loading={this.state.isBusy} bordered dataSource={dataAuthorsVillage} pagination={false} size='small' style={{fontSize:'x-large', marginLeft:'10px'}} >
                        <ColumnGroup title={ <div style={{fontWeight:'bold', fontSize:'x-large' }}> Autores por Pueblos</div>}>
                        <Column title={(<div style={{ fontWeight:'bold', fontSize:'large'}}>
                          Pueblo</div>)} dataIndex="village" key="genre" align='center'
                          render = {(text,record)=> {
                            return {
                              props: {
                                style: { background: "white",fontSize:'large' }
                              },
                              children: <div>{text}</div>
                            }} }
                          
                            />
                            
                        
                              <Column title={(<div style={{  fontSize:'large'}}>Hoy</div>)} dataIndex={"today"} key="todayPlays" align='center' render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:"white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                              <Column title={(<div style={{ fontSize:'large'}}>Total</div>)}dataIndex={"total"} key="totalPlays"  align='center'render = {(text,record)=> {
                                return {
                                  props: {
                                    style: { background:  "white",fontSize:'large' }
                                  },
                                  children: <div>{text}</div>
                                }} } />
                         
                
                        </ColumnGroup>
                      </Table>
                      </Row>
                      <br/>
                    </Col>
                  </Row>

                  {this.state.makeGenreReport &&
                  <Modal
                  closable = {false}
                  title="Reporte por género"
                  visible={this.state.makeGenreReport}
                  footer={[
                    <Button key="back" onClick={onClosekGenreReport}>
                    Regresar
                    </Button>,
                ]}
                  >
                      <Select
                      style={{width:'80%'}}
                      defaultValue={this.state.reportGenre}
                      onChange={onChangeReportGenre}
                      >
                        {Object.entries(this.state.genres).map(element => {if(element[1].nombre!='Admin')return <Option value={element[1].nombre}>{element[1].nombre}</Option>})}
                      </Select>
                      <div>
                        <br/>
                        <Button onClick={this.state.reportByAuthor ? readPlayReportGenre: readPlayReportGenrePseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportGenre: downloadPlayReportGenrePseudo}>Descargar</Button>
                      </div>
                  </Modal>}

                  {this.state.makeCountryReport &&
                  <Modal
                  closable = {false}
                  title="Reporte por país"
                  visible={this.state.makeCountryReport}
                  footer={[
                    <Button key="back" onClick={onClosekCountryReport}>
                    Regresar
                    </Button>,
                ]}
                  >
                      <Select
                      style={{width:'80%'}}
                      defaultValue={this.state.reportCountry}
                      onChange={onChangeReportCountry}
                      >
                        {Object.entries(dataAuthorsCountry).map(element => {return <Option value={element[1].country}>{element[1].country}</Option>})}
                      </Select>
                      <div>
                        <br/>
                        <Button onClick={this.state.reportByAuthor ? readPlayReportSelectedCountry: readPlayReportSelectedCountryPseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportSelectedCountry: downloadPlayReportSelectedCountryPseudo}>Descargar</Button>
                      </div>
                  </Modal>}
              </Content>
              </Layout>
            </ConfigProvider>
        </div>
        <Foot admin={true}/>
        </div>

        );
  }
}
export default AdminHome;


